// extracted by mini-css-extract-plugin
export const slide = "gallery-module--slide--1nD7Y";
export const image = "gallery-module--image--1LNea";
export const caption = "gallery-module--caption--3uW-H";